export const API_DOMAIN =
  "https://script.google.com/macros/s/AKfycbwpBDp51U6tRBM9MC_3-QYAOSsEoyoYtcwWOWxXBwy8FhcEy7FcltekRybuZOfmfv3EgQ/exec";
